<template>
  <svg :class="svgClass" aria-hidden="true" v-on="$listeners">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'TpIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      return [
        'tp-icon',
        {
          [this.className]: !!this.className
        }
      ]
    }
  }
}
</script>

<style scoped>
.tp-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor !important;
  overflow: hidden;
  flex: none;
}
.tp-icon[disabled] {
  cursor: not-allowed !important;
  pointer-events: none;
}
</style>
